// Destinos de la propina según el QR (punto de cobro): empleados, unidades
// de trabajo o todo el equipo. Lo comparten el formulario de propina y la
// pantalla de pagar la cuenta de la mesa.

export function getActiveUnidades(nuclioNegocio, cargoIdsWithTipeds = null) {
  return (nuclioNegocio?.unidadesTrabajo || [])
    .filter((u) => u.activoEnQr)
    .map((u) => {
      const cargo = u.cargo || {};
      return {
        cargoId: cargo._id || u.cargo,
        name: cargo.name || {},
        avatar: cargo.avatar || "",
        orden: cargo.orden,
      };
    })
    .filter((u) => u.cargoId)
    .filter(
      (u) => !cargoIdsWithTipeds || cargoIdsWithTipeds.has(String(u.cargoId)),
    );
}

export function buildVisibleDestinoChips(nuclio, activeUnidades, tipeds) {
  if (!nuclio) return [];
  const chips = [];
  if (nuclio.propinaDirecta) {
    tipeds.forEach((t) => chips.push({ type: "tiped", id: t._id, tiped: t }));
  }
  if (nuclio.mostrarUnidades) {
    activeUnidades.forEach((u) =>
      chips.push({ type: "unidad", id: u.cargoId }),
    );
  }
  if (nuclio.repartoColectivo) chips.push({ type: "colectivo" });
  return chips;
}

export function isSoloRepartoColectivo(chips) {
  return chips.length === 1 && chips[0].type === "colectivo";
}

export function shouldShowChipSelector(chips) {
  if (chips.length === 0) return false;
  if (isSoloRepartoColectivo(chips)) return false;
  return true;
}

export function filterTipedsForNuclio(tipedsList, nuclioNegocio) {
  const activos = tipedsList.filter((t) => t.active && !t.deleted);
  if (!nuclioNegocio?.propinaDirecta) return [];

  const activeCargoIds = new Set(
    (nuclioNegocio.unidadesTrabajo || [])
      .filter((u) => u.activoEnQr)
      .map((u) => String(u.cargo?._id || u.cargo)),
  );

  if (!activeCargoIds.size) return [];

  return activos.filter((t) =>
    activeCargoIds.has(String(t.cargo?._id || t.cargo)),
  );
}

function getTipedSortKey(tiped) {
  const alias = String(tiped?.alias || "").trim();
  if (alias) return alias;
  return `${tiped?.nombre || ""} ${tiped?.apellidos || ""}`.trim();
}

export function sortTipedsForDestino(tipedsList) {
  return [...tipedsList].sort((a, b) =>
    getTipedSortKey(a).localeCompare(getTipedSortKey(b), "es", {
      sensitivity: "base",
    }),
  );
}
